import { Box, ImageList, Typography } from '@mui/material';
import { useGetAllAssets } from 'src/hooks';
import { getThumbnailSrc } from 'src/utils/gcf-helper';

import { ResourceSelectorSidebarItem } from '../../../resourceSelectorSidebarWidget/resourceSelectorSidebarItem';
import type { AssetsThemeGroupProps } from './AssetsThemeGroup.interface';

export const AssetsThemeGroup = (props: AssetsThemeGroupProps) => {
  const { data: assets = [] } = useGetAllAssets();

  return (
    <Box>
      <Typography fontWeight="500">{props.label}</Typography>

      <ImageList cols={3} gap={6} rowHeight={120}>
        {(props.ccAssets ?? []).map((ccAsset) => (
          <ResourceSelectorSidebarItem
            key={ccAsset.id}
            fileName={ccAsset.name}
            src={
              assets.find((item) => ccAsset.name === item.fileName)
                ?.thumbnailUrl ?? getThumbnailSrc(ccAsset.name)
            }
            isSelected={false}
            onClick={() =>
              props.handleAssetChange(ccAsset, props.productVariationCode)
            }
          />
        ))}
      </ImageList>
    </Box>
  );
};
